export const freeTrial = {
    job1: '老板/总监/经理',
    job2: '设计师',
    job3: '项目经理/工长',
    job4: '销售/店长/导购/个体经营',
    job5: '学生/业主',
    job6: '个人爱好',
    job7: '其他',
    message: '【企业名称】不少于2个字',
    message1: '【企业名称】不可输入数字及特殊字符',
    message2: '请输入您的【姓名】',
    message3: '【姓名】仅可输入中英文',
    message4: '请选择您的【职务】',
    message5: '请输入您的【手机号】',
    message6: '请输入正确的【手机号】',
    message7: '申请试用企业版',
    message8: '请输入您所在的企业名称',
    message9: '请输入您的姓名',
    message10: '请选择您的职务',
    message11: '请输入您的手机号',
    freeTrial: '申请试用',
    submit: '提交',
    successTip: {
        submitSuccess: '提交成功！',
        submitSuccessMessage: ' 唤醒微信客服，回复 “问题关键词序号”',
        submitSuccessMessage1: '可加快申请通过速度',
        submitSuccessMessage2: '点击去唤醒',
    }
}
